import DybrPagination from '@/components/DybrComponents/DybrPagination';
import { DiscussionItem } from './DiscussionItem';
import css from './DiscussionsPage.module.css';
import type { DiscussionGroup, FilterMode } from './types';

const LABELS = {
  colTopic: 'Тема',
  colBlog: 'Блог',
  colComments: 'Комментарии',
  colMentions: 'Упоминания',
  colDate: 'Дата',
  empty: 'Обсуждений пока нет'
};

interface Props {
  discussions: DiscussionGroup[];
  totalRecords: number;
  currentPage: number;
  pageSize: number;
  showPagination: boolean;
  filterMode: FilterMode;
}

export function DiscussionsList({
  discussions,
  totalRecords,
  currentPage,
  pageSize,
  showPagination,
  filterMode
}: Props) {
  const showBlogColumn = filterMode === 'otherBlogs' || filterMode === 'mentions';
  const commentsLabel = filterMode === 'mentions' ? LABELS.colMentions : LABELS.colComments;

  if (discussions.length === 0) {
    return <div className={css.empty}>{LABELS.empty}</div>;
  }

  return (
    <>
      <div className={css.table}>
        <div className={css.tableHeader}>
          <div className={css.colExpand} />
          <div className={css.colTopic}>{LABELS.colTopic}</div>
          {showBlogColumn && <div className={css.colBlog}>{LABELS.colBlog}</div>}
          <div className={css.colComments}>{commentsLabel}</div>
          <div className={css.colDate}>{LABELS.colDate}</div>
        </div>

        {discussions.map(group => (
          <DiscussionItem key={group.entryId} group={group} showBlogColumn={showBlogColumn} />
        ))}
      </div>

      {showPagination && (
        <DybrPagination
          backgroundColor={null}
          totalRecords={totalRecords}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      )}
    </>
  );
}
